import { postRequest, getRequest } from 'utils/axios'

export const fetchArticleProviders = (teamUuid) => {
  const url = `v2/teams/${teamUuid}/article-providers`

  return getRequest(url)
}

export const fetchClubArticleCategories = (clubUuid, queryOptions = {}) => {
  const url = `v2/clubs/${clubUuid}/article-categories`

  return getRequest(url, queryOptions)
}

export const fetchTeamArticles = (teamUuid, filterParams = {}) => {
  const url = `v2/teams/${teamUuid}/articles`

  return getRequest(url, filterParams)
}

export const fetchFavouriteArticles = (teamUuid, filterParams = {}) => {
  const url = `v2/teams/${teamUuid}/favorite-content`

  return getRequest(url, filterParams)
}

export const updateFavoriteArticle = (contentUuid, favorite) => {
  const url = `v2/content/${contentUuid}/favorite`
  const data = { favorite }

  return postRequest(url, data)
}
